import { useEffect, useRef } from 'react';
import _get from 'lodash/get';
import { Counter, useAssetCounterQuery } from 'graphql-common';
import { ErrorLike } from '@apollo/client';

type Args = {
  id?: string;
  assetId?: string;
  skip?: boolean;
  onError?: (error: ErrorLike) => void;
};

export type UseAssetCounterQueryHookResult = {
  data: Counter;
  loading: boolean;
  error: ErrorLike | undefined;
  refetch: () => void;
};

export default function useAssetCounterQueryHook(
  args: Args,
): UseAssetCounterQueryHookResult {
  const { id = '', assetId = '', skip = true, onError } = args;
  const query = useAssetCounterQuery({
    skip,
    variables: { findBy: { id }, assetFindBy: { id: assetId } },
    fetchPolicy: 'network-only',
  });
  const { loading, error, refetch } = query;
  const data = _get(query, 'data.data') as Counter;

  const onErrorRef = useRef(onError);
  onErrorRef.current = onError;
  useEffect(() => {
    if (error) {
      onErrorRef.current?.(error);
    }
  }, [error]);

  return {
    data,
    loading,
    error,
    refetch,
  };
}
